import { SET_PAST_BOOKING, CLEAR_PAST_BOOKINGS } from '../constants';
import { bookingResponseFormatter } from './formatters/booking';

export default function bookingReducer(state = {}, action) {
  let newState = null;
  switch (action.type) {
    case SET_PAST_BOOKING:
      newState = { ...state };
      newState[action.payload.value.id] = bookingResponseFormatter(action.payload.value);
      return newState;
    case CLEAR_PAST_BOOKINGS:
      return {};
    default:
      return state;
  }
}
